<template>
  <div class="main_warp">
    <div class="main main_w">
      <upload-head
        @seachVal="getFileName"
        @uploadFile="getUploadFile"
      ></upload-head>
      <tableTemplate
        ref="child"
        @fileTypeEvent="getfileType"
        @delCurRow="deleteCourseware"
        :tableData="tableData"
      ></tableTemplate>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import UploadHead from "../components/upload-head";
import tableTemplate from "../components/tableTemplate";
import api from "../request/service/openClassApi";

export default {
  name: "liveCourseWare",
  components: {
    UploadHead,
    tableTemplate,
    // 2.定义实例
    loadingInstance: null,
  },
  computed: {},
  watch: {},
  data() {
    return {
      filName: "",
      fileType: 2,
      tableData: [
        {
          fileId: "1123",
          fileName: "123123",
          fileStatus: "完成",
          fileType: "3",
          uploadTime: "ewqe",
          videoType: "1",
        },
      ],
    };
  },
  created() {
    this.getFileList();
  },
  mounted() {},
  methods: {
    getFileName(e) {
      let _this=this;
      _this.fileName = e;
      _this.getFileList();
    },
    getfileType(e) {
      this.fileType = e;
      this.getFileList();
    },
    // 1、音频  2、视频  3、ppt 4、word 5、pdf
    getFileList() {
      let _this = this;
      this.loadingInstance = Loading.service({
        // 动画中的文字
        text: "加载中",
        // 要加载动画的容器
        target: ".app-container",
      });
      api
        .getFileList(
          _this.$store.getters.user.userId,
          _this.fileType,
          _this.fileName
        )
        .then((res) => {
          _this.tableData = res.infoObject;
          this.loadingInstance.close();
        });
    },
    getUploadFile(file) {
      var formData = new FormData();
      formData.append("upFile", file);
      formData.append("videoType", 1);
      formData.append("userId", this.$store.getters.user.userId);
      this.loadingInstance = Loading.service({
        // 动画中的文字
        text: "加载中",
        // 要加载动画的容器
        target: ".app-container",
      });
      axios({
        url: this.$url + "/live/video/Courseware/uploadFile.am",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.status == "y") {
            this.getFileList();
            this.$message({
              message: '上传成功',
              type: 'success'
            });
          }else{
            this.$message.error('上传失败');
          }
        }
        this.loadingInstance.close();
      });
    },
    deleteCourseware(index, row) {
      console.log("索引", index, row, this.tableData);
      this.$confirm("确定删除这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loadingInstance = Loading.service({
          // 动画中的文字
          text: "加载中",
          // 要加载动画的容器
          target: ".app-container",
        });
        api
          .deleteFile(this.$store.getters.user.userId, row.fileId)
          .then((res) => {
            console.log(res);
            if (res.state == "y") {
              this.getCoursewareList(this.$store.getters.user.userId);
            }
            this.tableData = this.tableData.filter(
              (o) => o.fileId != row.fileId
            );
          });
        this.loadingInstance.close();
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.main_warp {
  background: #f4f4f4;
}

.main {
  padding: 24px 0 26px;
  margin: 0 auto;
}
</style>
